import { render, staticRenderFns } from "./processConfiguration.vue?vue&type=template&id=0cbcde82&scoped=true"
import script from "./processConfiguration.vue?vue&type=script&lang=js"
export * from "./processConfiguration.vue?vue&type=script&lang=js"
import style0 from "./processConfiguration.vue?vue&type=style&index=0&id=0cbcde82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbcde82",
  null
  
)

export default component.exports